import { Component, OnInit } from '@angular/core';

@Component({
    templateUrl: './yunPos.component.html',
    styleUrls: ['./yunPos.component.css'],
})

export class YunPosComponent implements OnInit {
  constructor(
  ) {}

  ngOnInit() {
  }
}
